<template>
  <auth-layout title="Account Type" stepNo="2">
    <div class="text-darkBlue">
      <div class="text-center w-full md:w-3/5 mx-auto my-12">
        <h1 class="text-lg md:text-3xl font-bold">Select Account Type</h1>
      </div>

      <div class="w-full md:w-3/5 mx-auto font-semibold mt-12">
        <div class="flex gap-4 items-center">
          <el-tooltip
            class="item"
            effect="dark"
            content="A Third party logistics provider is an outsourcing company used by customers to fulfil their orders."
            placement="top-start"
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00042 0C3.58148 0 4.3409e-08 3.58148 4.3409e-08 7.99958C-0.000109406 9.05024 0.206753 10.0906 0.608773 11.0613C1.01079 12.032 1.60009 12.914 2.34302 13.657C3.08595 14.3999 3.96796 14.9892 4.93866 15.3912C5.90936 15.7932 6.94976 16.0001 8.00042 16C12.4177 16 16 12.4185 16 7.99958C16 3.58148 12.4177 0 8.00042 0ZM8.74704 2.88818C9.527 2.88818 9.75616 3.34066 9.75616 3.85813C9.75616 4.50393 9.23952 5.1014 8.35706 5.1014C7.61877 5.1014 7.26712 4.73059 7.28879 4.11645C7.28879 3.59898 7.72126 2.88818 8.74704 2.88818ZM6.74882 12.791C6.21551 12.791 5.82636 12.4669 6.19884 11.0461L6.80965 8.52539C6.91547 8.12208 6.93297 7.96042 6.80965 7.96042C6.65049 7.96042 5.95802 8.23874 5.54971 8.51372L5.28389 8.07791C6.57966 6.99547 8.06958 6.3605 8.70705 6.3605C9.24035 6.3605 9.32868 6.99047 9.06286 7.96042L8.3629 10.6103C8.23874 11.0786 8.29207 11.2402 8.41623 11.2402C8.57622 11.2402 9.09953 11.0469 9.6145 10.6411L9.91615 11.0461C8.65538 12.306 7.28129 12.791 6.74882 12.791Z"
                  fill="#606A83"
                />
              </svg>
            </span>
          </el-tooltip>

          <div
            :class="{ selected: mainAccountType == '3PL', groupselected : onboardingType == '3PL' }"
            class="single-option shadow"
            @click="toggleAccountType('3PL')"
          >
            <div class="single-option__inner">
              <div class="single-option__">
                <p>{{ logisticsTitle }}</p>
                <!-- <p>Organization</p> -->
              </div>
              <div class="single-option__select-circle">
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L6.75697 7L12.5139 1"
                    stroke="#10233E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- <div class="single-option__select-circle__inner"></div> -->
              </div>
            </div>
            <div class="actions" v-if="mainAccountType == '3PL'">
              <div
                :class="{ selected: accountType == 'N/A' }"
                class="disabled-option single-option shadow"
                @click="
                  selectAccountType('N/A', 'logistics', 'Independent Partner')
                "
              >
                <div class="single-option__inner">
                  <div class="single-option__">
                    <p>Independent Partner</p>
                  </div>
                  <div class="single-option__select-circle">
                    <div class="single-option__select-circle__inner"></div>
                  </div>
                </div>
              </div>
              <div
                :class="{ selected: accountType == 'organization' }"
                class="single-option shadow"
                @click="
                  selectAccountType(
                    'organization',
                    'logistics',
                    'Enterprise Partner'
                  )
                "
              >
                <div class="single-option__inner">
                  <div class="single-option__">
                    <p>Enterprise Partner</p>
                  </div>
                  <div class="single-option__select-circle">
                    <div class="single-option__select-circle__inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex gap-4 items-center">
          <el-tooltip
            class="item"
            effect="dark"
            placement="top-start"
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00042 0C3.58148 0 4.3409e-08 3.58148 4.3409e-08 7.99958C-0.000109406 9.05024 0.206753 10.0906 0.608773 11.0613C1.01079 12.032 1.60009 12.914 2.34302 13.657C3.08595 14.3999 3.96796 14.9892 4.93866 15.3912C5.90936 15.7932 6.94976 16.0001 8.00042 16C12.4177 16 16 12.4185 16 7.99958C16 3.58148 12.4177 0 8.00042 0ZM8.74704 2.88818C9.527 2.88818 9.75616 3.34066 9.75616 3.85813C9.75616 4.50393 9.23952 5.1014 8.35706 5.1014C7.61877 5.1014 7.26712 4.73059 7.28879 4.11645C7.28879 3.59898 7.72126 2.88818 8.74704 2.88818ZM6.74882 12.791C6.21551 12.791 5.82636 12.4669 6.19884 11.0461L6.80965 8.52539C6.91547 8.12208 6.93297 7.96042 6.80965 7.96042C6.65049 7.96042 5.95802 8.23874 5.54971 8.51372L5.28389 8.07791C6.57966 6.99547 8.06958 6.3605 8.70705 6.3605C9.24035 6.3605 9.32868 6.99047 9.06286 7.96042L8.3629 10.6103C8.23874 11.0786 8.29207 11.2402 8.41623 11.2402C8.57622 11.2402 9.09953 11.0469 9.6145 10.6411L9.91615 11.0461C8.65538 12.306 7.28129 12.791 6.74882 12.791Z"
                  fill="#606A83"
                />
              </svg>
            </span>
            <div width="300px" slot="content">
              A customer is a user that is in need of an outsourcing company that he or she can use to fulfil their shipping needs.
            </div>
          </el-tooltip>
          <div
            :class="{ selected: mainAccountType == 'ondemand', groupselected : onboardingType == 'ondemand' }"
            class="single-option shadow single-option"
            @click="toggleAccountType('ondemand')"
          >
            <div class="single-option__inner">
              <div class="single-option__">
                <p>{{ customerTitle }}</p>
              </div>
              <div class="single-option__select-circle">
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L6.75697 7L12.5139 1"
                    stroke="#10233E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- <div class="single-option__select-circle__inner"></div> -->
              </div>
            </div>
            <div class="actions" v-if="mainAccountType == 'ondemand'">
              <div
                :class="{ selected: accountType == 'individual' }"
                class="single-option shadow"
                @click="
                  selectAccountType(
                    'individual',
                    'customer',
                    'Private Customer'
                  )
                "
              >
                <div class="single-option__inner">
                  <div class="single-option__">
                    <p>Private Customer</p>
                  </div>
                  <div class="single-option__select-circle">
                    <div class="single-option__select-circle__inner"></div>
                  </div>
                </div>
              </div>

              <div
                :class="{ selected: accountType == 'individual' }"
                class="shadow disabled-option"
                @click="
                  selectAccountType(
                    'individual',
                    'customer',
                    'Enterprise Customer'
                  )
                "
              >
                <div class="single-option__inner">
                  <div class="single-option__">
                    <p>Enterprise Customer</p>
                  </div>
                  <div class="single-option__select-circle">
                    <div class="single-option__select-circle__inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-12">
          <!-- <button class="account-type__form__back-btn" @click="goToPreviousPage">
          Back
        </button> -->
          <base-button
            text="Continue"
            width="w-full"
            p="py-3"
            :loading="savingAccountType"
            @click="saveAccountType"
          />
        </div>
      </div>
    </div>
    
    <template v-slot:text>
      <div class="text-white">
        <h1 class="text-3xl font-bold">Account Type</h1>
      </div>
    </template>
  </auth-layout>
</template>

<script>
// import OnboardingLayoutOne from "../Layouts/use-case-account-type/index";
import AuthLayout from "../../Auth/Authlayout/OnDemand";
export default {
  components: {
    // OnboardingLayoutOne,
    AuthLayout,
  },
  data() {
    return {
      mainAccountType: "organization",
      onboardingType: "",
      accountType: "organization",
      savingAccountType: false,
      logisticsTitle: "3rd Party Logistics Provider",
      customerTitle: "Customer",
      accountGroup : ""
    };
  },
  methods: {
    toggleAccountType(accountType) {
      this.onboardingType = accountType;
      if (this.mainAccountType == accountType) {
        this.mainAccountType = "";
      } else {
        this.mainAccountType = accountType;
      }
    },
    selectAccountType(accountType, group, title) {
      this.accountGroup = group
      switch (group) {
        case "logistics":
          this.logisticsTitle = title;
          break;
        case "customer":
          this.customerTitle = title;
          break;
      }
      this.accountType = accountType;
    },
    async saveAccountType() {
      this.savingAccountType = true;

      if (this.accountType != "N/A") {
        // accounttypeRequest
        let accountTypeRequest = {
          type: this.accountType,
        };
        let userId = localStorage.getItem("userId");
        accountTypeRequest.userId = userId;

        let userCaseRequest = {
          // can be termed use case
          onboardingType: this.onboardingType,
        };
        // let quantumUserId = localStorage.getItem("quantumUserId");
        userCaseRequest.userId = userId;

        try {
          let usecaseresponse = await this.$_saveUserUseCase(userCaseRequest);

          let acounttyperesponse = await this.$_saveUserAccountType(
            accountTypeRequest
          );
          Promise.all([usecaseresponse, acounttyperesponse]).then((values) => {
            console.log(values);
            this.handleSuccessfulResponse();
          });
          // console.log(response);
        } catch (error) {
          this.savingAccountType = false;
          this.handleError(error);
          console.log(error);
        }
      } else {
        this.savingAccountType = false;
        await this.generateToast(
          "Feature not available yet! try another..",
          "error"
        );
      }
    },
    handleSuccessfulResponse() {
      this.savingAccountType = false;
      this.storeTypeToLocalStorage();
      this.$router.push("/onboarding/account-owner");
    },
    storeTypeToLocalStorage() {
      localStorage.setItem("account-type", this.accountType);
    },
    goToPreviousPage() {
      this.$router.push("/onboarding/use-case");
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  position: absolute;
  background: #ffffff;
  top: 80px;
  z-index: 999;
  font-size: 0.9rem;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  padding: 1rem;

  span {
    padding-right: 0.25rem;
  }

  > div {
    display: flex;
    align-items: center;
    padding: 0.75rem;

    &:hover {
      background: rgb(225, 225, 225);
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
}

.single-option {
  width: 100%;
  height: 4.5rem;
  border-radius: 5px;
  margin: 0.75rem 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* transition: transform ease 0.5s; */
  border: 1px solid #dae8f6;
  position: relative;
}

.single-option:hover {
  //transform: scale(1.015);
}

.single-option.selected {
  border: none;
  background: #fbc210;
}
.groupselected{
  border: none;
  background: #fbc210;
}

.single-option__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  padding: 0 0.5rem;
  width: 100%;
  height: 70%;
  border-radius: 5px;
}

/* .single-option.selected .single-option__inner {
} */

.single-option__select-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 0.5px solid #eff2f7;
}

.single-option__select-circle__inner {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #eff2f7;
}

.disabled-option{
  color: rgba(174, 174, 185, 0.956);
  background-color: #e7e7e9;
}

@media screen and (max-width: 768px) {
  .single-option {
    width: 90vw;
  }
}
</style>
